export default __webpack_public_path__ + "static/media/box1bak3.3138dd88.png";